import { Container, Button, ButtonGroup } from 'reactstrap';
import { useForm } from "react-hook-form"
import axios from 'axios';
import useToken from '../../useToken';
import { useGetAgentQuery } from '../../../features/CallApi';
import { useParams, useNavigate } from 'react-router-dom';
import LoadScreen from '../../UI/LoadScreen';


export const AgentsEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const { isLoading, data, refetch, error, isFetching } = useGetAgentQuery(id);
    const { token } = useToken();

    const putAgents = async (data) => {
        const response = await axios.put(`/api/agents/${id}`, data, {
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                Authorization: "Bearer " + token
            }
        })

        if (response.status >= 200 || response.status <= 204) {
            console.log(data)
            refetch()
            navigate('/admin/agents')
            // console.log(response.data)
        }
    }

    return (
        <Container>
            <div>
                {isLoading ? <LoadScreen /> :
                    <div>
                        {error ? <div>
                            <h2>{error.status}</h2>
                            <p>{error.data.title}</p>
                        </div> : <div>
                            {data && data.length > 0 ? <h1>{error}</h1> :
                                <form onSubmit={handleSubmit(putAgents)} key={data.id}>
                                    <input hidden value={data.id} {...register("id", {})} />

                                    <div className="mb-3">
                                        <label htmlFor="operation" className="form-label">Наименование операции</label>
                                        <input id="operation" defaultValue={data.operation} name="operation" placeholder="Наименование операции" type="string" className="form-control"
                                            {...register("operation", {
                                                required: { value: true, message: "Поле \"Наименование операции\" не может быть пустым" }
                                            })} />
                                        {errors.operation && <span className='text-danger'>{errors.operation?.message}</span>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phones" className="form-label">Телефон (без +7)</label>
                                        <input id="phones" defaultValue={data.phones} name="phones" placeholder="Телефон" type="number" className="form-control"
                                            {...register("phones", {
                                                required: { value: true, message: "Поле \"Телефон\" не может быть пустым" }
                                            })} />
                                        {errors.phones && <span className='text-danger'>{errors.phones?.message}</span>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Наименование организации</label>
                                        <input id="name" defaultValue={data.name} name="name" placeholder="Наименование организации" type="string" className="form-control"
                                            {...register("name", {
                                                required: { value: true, message: "Поле \"Наименование организации\" не может быть пустым" }
                                            })} />
                                        {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="addres" className="form-label">Юр.адресс</label>
                                        <input id="addres" defaultValue={data.addres} name="addres" placeholder="Юр.адресс" type="string" className="form-control"
                                            {...register("addres", {
                                                required: { value: true, message: "Поле \"Юр.адресс\" не может быть пустым" }
                                            })} />
                                        {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="tin" className="form-label">ИНН</label>
                                        <input id="tin" defaultValue={data.tin} name="tin" placeholder="ИНН" type="number" className="form-control"
                                            {...register("tin", {
                                                required: { value: true, message: "Поле \"ИНН\" не может быть пустым" }
                                            })} />
                                        {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                    </div>
                                    <ButtonGroup>
                                        <Button color="success">
                                            Сохранить
                                        </Button>
                                        <Button color="warning" onClick={() => navigate(`/admin/agents`)}>
                                            Отмена
                                        </Button>
                                    </ButtonGroup>
                                </form>
                            }
                        </div>
                        }
                    </div>
                }
            </div>
        </Container>
    )

}